import React from 'react';

const AddCircleIcon = (props) => {
  let fill = props.fill ? props.fill : '#000';
  let fillOpacity = props.fill ? 1 : 0.38;
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.911133"
        y="0.670532"
        width="27.0001"
        height="27.0001"
        rx="13.5001"
        fill="black"
        fill-opacity="0.4"
      />
      <path
        d="M18.6839 14.781H15.0217V18.4432H13.8009V14.781H10.1387V13.5602H13.8009V9.89795H15.0217V13.5602H18.6839V14.781Z"
        fill="white"
      />
    </svg>
  );
};

export default AddCircleIcon;
